import React, { memo } from "react";

import { classNames } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { NotificationSceneProps } from "../types";

/** Korak "Postavke obavijesti": pregled poruke kako stiže u sandučić, pa odabrani kanali. */
const NotificationMessageScene: React.FC<NotificationSceneProps> = ({ notification }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Pregled poruke</div>
          <div className="mt-3 flex items-center gap-2">
            <span className="flex items-center justify-center w-7 h-7 rounded-full bg-blue-600 text-[0.6rem] font-bold text-white">AB</span>
            <div className="min-w-0">
              <div className="text-[0.7rem] font-semibold text-slate-800">Orytron</div>
              <div className="text-[0.6rem] text-slate-400">obavijesti@orytron.com</div>
            </div>
          </div>
          <div className="mt-3 text-sm font-bold text-slate-800 truncate">{notification.title}</div>
          <p className="mt-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem] leading-relaxed text-slate-600 line-clamp-5">
            {notification.message}
          </p>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Kanali</div>
          <div className="mt-3 grid grid-cols-3 gap-1.5">
            {notification.channels.map((channel) => (
              <div
                key={channel.label}
                className={classNames(
                  "rounded-md py-2 text-center text-[0.65rem] font-semibold",
                  channel.isActive ? "bg-amber-50 text-amber-700 ring-1 ring-amber-300" : "bg-slate-50 text-slate-400"
                )}
              >
                {channel.label}
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Oznake se popune same"
          subtitle="Naziv, datum i broj dana"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 4h16v12H5.17L4 17.17V4z" />
              <path d="M8 9h8M8 12h5" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NotificationMessageScene);
